import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';

// @source
import Flag from './Flag';
import InlineMessage from './InlineMessage';
import Modal from './Modal';
import SectionMessage from './SectionMessage';

/**
 * Multiple message notifications using Atlaskit components.
 *
 * @class
 * @param {string=} appearance Message style appearance
 * @param {string} component Component name to use
 * @param {Object[]} items Messages to display
 * @param {function} onClose Messages off function
 */

class Messages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: this.props.items.map(item => ({
        key: uuid(),
        ...item,
      })),
    };
    this.onClose = this.onClose.bind(this);
  }

  onClose(key) {
    const items = this.state.items.filter(item => item.key !== key);

    if (items.length) {
      this.setState({ items });
    } else {
      this.props.onClose();
    }
  }

  getClassComponent() {
    const { component } = this.props;

    if (component === 'InlineMessage') {
      return InlineMessage;
    } if (component === 'Modal') {
      return Modal;
    } if (component === 'Flag') {
      return Flag;
    }

    return SectionMessage;
  }

  render() {
    const RefComponent = this.getClassComponent();
    return this.state.items.map(item => (
      <RefComponent
        appearance={this.props.appearance}
        {...item}
        onClose={() => this.onClose(item.key)}
      >
        {item.description}
      </RefComponent>
    ));
  }
}

Messages.propTypes = {
  appearance: PropTypes.string,
  component: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClose: PropTypes.func.isRequired,
};

Messages.defaultProps = {
  appearance: 'error',
  component: 'SectionMessage',
};

export default Messages;
